"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _fs = _interopRequireDefault(require("fs"));

var _postcss = _interopRequireDefault(require("postcss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default() {
  return function (_ref) {
    var addBase = _ref.addBase;

    var normalizeStyles = _postcss.default.parse(_fs.default.readFileSync(require.resolve('normalize.css'), 'utf8'));

    var preflightStyles = _postcss.default.parse(_fs.default.readFileSync("".concat(__dirname, "/css/preflight.css"), 'utf8'));

    addBase([].concat(_toConsumableArray(normalizeStyles.nodes), _toConsumableArray(preflightStyles.nodes)));
  };
}